import { ClioFolder } from '~/src/types/clioDocumentPicker';
import { FolderData } from '../../types';

export const transformFoldersToFolderData = (
  folders: ClioFolder[],
  level: number = 0,
  parentId?: number | null,
): FolderData[] => {
  return folders.map((folder: ClioFolder) => ({
    id: folder.id,
    name: folder.name,
    level,
    parentId: parentId,
    expanded: false,
    isSelected: false,
  }));
};
